import React from 'react';
import LocationTemplate from './LocationTemplate';

const RoperPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Roper"
      stateName="North Carolina"
      countyName="Washington"
      zipCodes={["27970"]}
      latitude={35.8718}
      longitude={-76.6180}
      population={613}
      historicalFact="Named after John Roper, a colonial-era landowner; incorporated in 1905."
      nearbyTowns={[
        "Plymouth, NC",
        "Columbia, NC",
        "Creswell, NC",
        "Washington, NC",
        "Williamston, NC",
        "Colerain, NC",
        "Edenton, NC",
        "Pantego, NC"
      ]}
    />
  );
};

export default RoperPage;